var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9999 8.8091V14H10.9992V9.15676C10.9992 7.94009 10.5652 7.10977 9.47909 7.10977C8.64996 7.10977 8.15655 7.66935 7.93948 8.21065C7.86032 8.40416 7.83994 8.6735 7.83994 8.94438V14H4.83828C4.83828 14 4.87871 5.79713 4.83828 4.94724H7.83965V6.23044C7.83356 6.24004 7.82565 6.25039 7.81993 6.25969H7.83965V6.23044C8.23841 5.61448 8.95056 4.73457 10.5446 4.73457C12.5194 4.73454 13.9999 6.02844 13.9999 8.8091ZM1.69852 0.583984C0.671654 0.583984 0 1.25948 0 2.14779C0 3.01673 0.652223 3.71273 1.65868 3.71273H1.67873C2.72548 3.71273 3.37647 3.01686 3.37647 2.14779C3.35674 1.25948 2.72548 0.583984 1.69852 0.583984ZM0.177539 14.0006H3.17806V4.94785H0.177539V14.0006Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4f7b9109ee9fd65b890e15938e4dca64.svg";
export { ForwardRef as ReactComponent };